import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../../../css/public/pricing.css';
import { Select, MenuItem, FormControl, InputLabel, Box, Typography } from '@mui/material';
import WhatsappMarketingPlans from './WhatsappMarketingPlans';
import EmailTransactionalPlans from './EmailTransactionalPlans';

const EmailPlans = () => {
  const [activePlan, setActivePlan] = useState('marketing');

  return (
    <div className="email-plans-body">
      
      {activePlan === 'marketing' && <WhatsappMarketingPlans />}
    </div>
  );
};

export default EmailPlans;
